import React from 'react';
import { MdDragIndicator } from 'react-icons/md';
import { useDraggableItem } from '../../hooks/useDragAndDrop';
import './DnD.scss';

/**
 * Reusable draggable item component
 * @param {string} type - The drag type
 * @param {object} item - The item data
 * @param {number} index - The item's position
 * @param {ReactNode} children - The content to render
 * @param {string} className - Additional CSS classes
 * @param {boolean} showDragHandle - Whether to show the drag handle
 * @param {string} dragHandlePosition - Position of drag handle ('left' or 'right')
 * @param {function} onDragEnd - Callback when drag ends
 */
const DraggableItem = ({
    type,
    item,
    index,
    children,
    className = '',
    showDragHandle = true,
    dragHandlePosition = 'left',
    onDragEnd = null
}) => {
    const { isDragging, drag, preview } = useDraggableItem(type, item, index, onDragEnd);

    return (
        <div
            ref={preview}
            className={`draggable-item ${className} ${isDragging ? 'dragging' : ''}`}
            data-item-id={item.id}
        >
            {showDragHandle && dragHandlePosition === 'left' && (
                <div ref={drag} className="drag-handle drag-handle-left">
                    <MdDragIndicator />
                </div>
            )}
            
            <div className="draggable-content">
                {children}
            </div>

            {showDragHandle && dragHandlePosition === 'right' && (
                <div ref={drag} className="drag-handle drag-handle-right">
                    <MdDragIndicator />
                </div>
            )}
        </div>
    );
};

export default DraggableItem;
